import React, { useState, useContext, useEffect } from "react";
import MemberProfilePage from "./Layout/MemberProfilePage";
import Messaging from "./Layout/Messaging";
import AudioCall from "./Layout/AudioCall";
import VideoCall from "./Layout/VideoCall";
import LiveStream from "./Layout/LiveStream";
import BloggingProfile from "./Layout/Blogging";
import AdmirerProfile from "./Layout/Admirer";
import GroupsProfile from "./Layout/Groups";
import CollaborationProfile from "./Layout/Collaboration";
import ExploreProfile from "./Layout/Explore";
import CreatePost from "./Layout/Post";
import ReelsProfile from "./Layout/Reels";


// import { ThemeContext } from "../../../context/ThemeContext";

const MasterOperationRenderer = ({ operationType, data, profileId }) => {
  switch (operationType) {
    case "page":
      return <MemberProfilePage userId={data.userId} />;
    case "videos":
      return <VideoCall userId={data.userId} />;
    case "deepdive":
      return <LiveStream streamId={data.streamId} />;
      case "history":      
      return <BloggingProfile userId={data.userId} profileId={profileId}/>;
    case "admirer":
      return <AdmirerProfile userId={data.userId} profileId={profileId}/>;
    case "groups": 
      return <GroupsProfile userId={data.userId} profileId={profileId}/>;
    case "collaboration": 
      return <CollaborationProfile userId={data.userId} profileId={profileId}/>;
    case "explore":
      return <ExploreProfile userId={data.userId} profileId={profileId}/>;
    case "reels":
      return <ReelsProfile userId={data.userId} profileId={profileId}/>;
    case "post":
      return <CreatePost userId={data.userId} profileId={profileId}/>;
    default:
      return <div>Invalid Operation</div>;
  }
};

export default MasterOperationRenderer;
